import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { environment } from 'src/environments/environment';

@Injectable()

export class AuthInterceptor implements HttpInterceptor{

  constructor(private auth: AuthService) { }  
    
    intercept(req: HttpRequest<any>, next: HttpHandler) {
      if (req.headers.has('skip_token_interceptor')) {
        // skip token header and pass the request to the next handler (For proctoring api)
        return next.handle(req);
      }
        const authRequest = req.clone({ setHeaders: { Authorization: `Bearer ${this.auth.token}` }});
        return next.handle(authRequest);
    }
}